import { ContentHeader, IconArrowRightRegular, IconShoppingbagSolid, Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { ComponentProps, LookBookComponentType } from '@domains/storehome-common';

import { useLookbookService } from '../services/useLookbookService';

interface Props extends ComponentProps<LookBookComponentType> {}

export const LookbookContainer = ({ component: lookbook_component }: Props) => {
  const { title, image_url_list, action_button } = lookbook_component;
  const is_valid_image_count = image_url_list.length === 3;
  const { moveToCollectionPage } = useLookbookService({});

  const getRatioImage = (image_url: string) => {
    return (
      <>
        <Dimmed />
        <Image src={image_url} />
      </>
    );
  };

  return (
    <Root onClick={() => moveToCollectionPage(action_button?.link_url)}>
      <ContentHeader
        title={title}
        right={{
          type: 'text-button',
          icon: IconArrowRightRegular,
          text: action_button?.text ?? '더 보기',
        }}
      />
      <LookBookGrid>
        {is_valid_image_count && (
          <>
            <FirstImageWrap>{getRatioImage(image_url_list[0])}</FirstImageWrap>
            <SecondImageWrap>{getRatioImage(image_url_list[1])}</SecondImageWrap>
            <ThirdImageWrap>{getRatioImage(image_url_list[2])}</ThirdImageWrap>
          </>
        )}

        {action_button && (
          <ProductMoreBadge>
            <IconShoppingbagSolid size={16} color='staticWhite' />
            <Text as='span' variant='Caption_12_SemiBold' color='staticWhite'>
              더 보기
            </Text>
          </ProductMoreBadge>
        )}
      </LookBookGrid>
    </Root>
  );
};

const Root = styled.section`
  position: relative;
  padding: 0 0 36px;
`;

const LookBookGrid = styled.div`
  display: grid;
  grid-template-columns: 228fr 113fr;
  gap: 2px;
  position: relative;
  background-color: ${vars.color.staticWhite};
  margin: 0 16px;
  overflow: hidden;
  cursor: pointer;
`;

const FirstImageWrap = styled.div`
  position: relative;
  grid-row: 1 / 3;
  aspect-ratio: 228/274;
`;

const SecondImageWrap = styled.div`
  position: relative;
  aspect-ratio: 113/136;
`;

const ThirdImageWrap = styled.div`
  position: relative;
  aspect-ratio: 113/136;
`;

const Dimmed = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: ${vars.color.thumbnailDimmed};
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProductMoreBadge = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  padding: 7px 10px 6px 6px;
  left: 8px;
  bottom: 8px;
  background: ${vars.color.onImageBlackOpacity30};
  border-radius: 100px;
  cursor: pointer;

  > span {
    margin: 0 0 0 2px;
  }
`;
